import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { collection, collectionData, Firestore } from '@angular/fire/firestore';
import { Observable, of } from 'rxjs';
import { Offers } from '../../shared/models/offers.model';
import { HttpClient } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class OffersService {
  items$: Observable<any[]>;

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: Object,
    private readonly httpClient: HttpClient,
    private readonly firestore: Firestore
  ) {
    if (isPlatformBrowser(this.platformId)) {
      const itemCollection = collection(this.firestore, 'ofertas');
      this.items$ = collectionData(itemCollection);
    } else this.items$ = of([]);
  }

  public getFlightsOffers(): Observable<Offers[]> {
    return this.items$;
  }
}
